import styled from '@emotion/styled';

import StringInput from '../StringInput';

export const Container = styled.div`
	display: flex;
	gap: 1rem;

	body[dir='rtl'] & {
		direction: ltr;
	}

	.error-message-container {
		display: none;
	}

	> .disabled-view-field {
		width: 4.3rem;

		> .typography {
			width: 100%;
			text-align: center;
		}
	}
`;

export const StyledStringInput = styled(StringInput)`
	font-weight: 700;
	width: 4.3rem;
	text-align: center;
`;
